import { render, staticRenderFns } from "./header3Dian5.vue?vue&type=template&id=74b1c2b9&scoped=true"
import script from "./header3Dian5.vue?vue&type=script&lang=js"
export * from "./header3Dian5.vue?vue&type=script&lang=js"
import style0 from "./header3Dian5.vue?vue&type=style&index=0&id=74b1c2b9&prod&lang=css"
import style1 from "./header3Dian5.vue?vue&type=style&index=1&id=74b1c2b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1c2b9",
  null
  
)

export default component.exports